import { io, Socket } from "socket.io-client";
import { APP_API_URL } from "utils/constants";

const SOCKET_URL = APP_API_URL; // backend URL

export const socket: Socket = io(SOCKET_URL, {
  autoConnect: false,
  path: "/realtime/socket.io",
  transports: ["websocket"],
  reconnectionAttempts: 5, // ✅ Retry up to 5 times on drop
  reconnectionDelay: 2000, // ✅ Wait 2s before retrying
  reconnection: true,
  timeout: 10000,
});
// ✅ Online/offline status receive
socket.on("userStatus", ({ userId, isOnline, lastSeen, reason }) => {
  // console.log(`${userId} is ${isOnline ? "ONLINE" : "OFFLINE"}`);
  if (lastSeen) console.log(`Last seen: ${lastSeen}`);
  if (reason === "idle") console.log("User is idle/away");
});

// ✅ Activity send (mouse move, key press, etc.)
document.addEventListener("mousemove", () => {
  socket.emit("activity");
});
